import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brackets', 'IconBrackets', [["path",{"d":"M8 4h-3v16h3","key":"svg-0"}],["path",{"d":"M16 4h3v16h-3","key":"svg-1"}]]);